import React, { type JSX } from 'react';
import { Input } from '../../../formik/Input';
import { RadioGroup } from '../../../formik/RadioGroup';
import {
  FORMIK_PUPIL_EMAIL,
  validateEmail,
  validateNotEqualTo,
  validatePhone,
  validateRequired
} from '../../../formik/validate.formik';
import { FormikValues, useFormikContext } from 'formik';

/**
 * This component contains the main fields of the checkout form. The email
 * address of the pupil and parent cannot be the same.
 */
export const CaretakerFormSection = (): JSX.Element => {
  const { values }: FormikValues = useFormikContext();
  const show: boolean = values.type !== 'caretaker';
  return (
    <div className="px-3">
      <div className="row">
        <div className="col-sm-12">
          Ik ben een
        </div>
        <div className="col-sm-12">
          <RadioGroup name="type" items={[
            { value: 'pupil', label: 'Leerling' },
            { value: 'caretaker', label: 'Ouder/verzorger' },
          ]} validate={validateRequired}/>
        </div>
      </div>
      <div className="row">
        <div className="col-sm-12">
          <RadioGroup name="caretaker.gender" items={[
            { value: 'male', label: 'Man' },
            { value: 'female', label: 'Vrouw' },
          ]} validate={validateRequired}/>
        </div>
      </div>
      <div className="row my-3">
        <div className="col-sm-4">
          <Input
            name='caretaker.firstName'
            placeholder='Voornaam'
            validate={validateRequired}/>
        </div>
        <div className="col-sm-4">
          <Input
            name='caretaker.lastNamePrefix'
            placeholder='Tussenvoegsel'/>
        </div>
        <div className="col-sm-4">
          <Input
            name='caretaker.lastName'
            placeholder='Achternaam'
            validate={validateRequired}/>
        </div>
      </div>
      <div className="row my-3">
        <div className="col-sm-6">
          <Input
            name='caretaker.mobile'
            placeholder='Telefoonnummer'
            validate={(v: string): string => validateRequired(v) || validatePhone(v)}/>
        </div>
        <div className="col-sm-6">
          <div className={`extra-info extra-info__indicator ${show ? 'extra-info__show': ''}`}>*</div>
          <Input
            name='caretaker.email'
            placeholder='E-mailadres'
            validate={(v: string): string => validateRequired(v)
            || validateEmail(v)
            || validateNotEqualTo(v, values, 'pupil.email', FORMIK_PUPIL_EMAIL)}/>
        </div>
      </div>
    </div>
  );
};
